import { runAfterBootstrap } from 'owa-delayed-initialization';
import loadRegionalOptions from './orchestration/loadRegionalOptions';

// Load initial state needed for options
runAfterBootstrap(() => {
    loadRegionalOptions();
});

// Export option itself
export { default as RegionalOption } from './RegionalOption';
